import { Injectable } from "@angular/core";
import type { ItemsService } from "@app/@classes/abstract/items-service-interface";
import { ItemsTableServiceBase } from "@app/@classes/abstract/items-table-service";
import type { Tables } from "@app/@classes/supabase";

const TABLE = "locations";
type T = typeof TABLE;

@Injectable({
	providedIn: "root",
})
export class LocationsService
	extends ItemsTableServiceBase<Tables<T>>
	implements ItemsService<Tables<T>>
{
	constructor() {
		super(TABLE, { hasTenant: true });
	}

	override defaultItem(): Tables<T> {
		return {
			address: null,
			cap: null,
			company_id: null,
			contacts: null,
			created_at: null,
			created_by: null,
			email: null,
			phone_numbers: null,
			client_id: null,
			// exceptional_transport: false,
			id: this.randomUUID(),
			is_depot: false,
			latitude: null,
			city: null,
			country: null,
			external_identifier: null,
			location: null,
			longitude: null,
			name: null,
			// no_articulated_truck: false,
			// no_crane_articulated_truck: false,
			access: null,
			type: null,
			unload_mode: null,
			notes: null,
			opening_hours: null,
			province: null,
			referent: null,
			tenant_id: "",
			updated_at: null,
			updated_by: null,
			ztl: false,
		};
	}
}
